module.exports = __webpack_public_path__ + "img/health_thumbnail.e49c0971.jpg";